<template>
  <div>
    <div class="trial-wrapper">
      <!-- Trial Days -->
      <div class="trial-state">
        <TrialDays
          :content="trialContent"
          :trial="subscription.trial"
        ></TrialDays>
        <router-link
          to="/apps/translations/subscription"
          class="btn btn-primary btn-small"
        >
          <span>View plans</span>
        </router-link>
      </div>

      <!-- Trial Extension -->
      <TrialExtension
        :marketplaceUrl="trialExtenstionContent.marketplaceUrl"
        :steps="trialExtenstionContent.steps"
      ></TrialExtension>
    </div>

    <!-- Qucikstart Guides -->
    <QuickstartGuides
      :guides="selectedApp.quickstartGuides"
      @guideButtonClicked="markGuideCompleted"
    ></QuickstartGuides>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import TrialDays from "@/components/dashboard/subscription/trial/Days";
import TrialExtension from "@/components/dashboard/subscription/trial/Extension";
import QuickstartGuides from "@/components/dashboard/subscription/trial/QuickstartGuides";

// Services
import { TranslationsAppService } from "@/services";
const { CompanyService } = TranslationsAppService;

export default {
  name: "TrialCustomer",
  data() {
    return {
      lodash: _,
      showOptions: {
        headerShadow: false,
        unsavedChanges: false,
        lineLoader: false,
      },
      trialContent: {
        title: "Free Trial",
        description: "Try the AI Ticket Translations app for free",
      },
      trialExtenstionContent: {
        marketplaceUrl:
          "https://www.zendesk.com/marketplace/apps/support/1166071",
        steps: {
          title: "How to extend your trial",
          list: [
            'Scroll down to reviews <a href="https://www.zendesk.com/marketplace/apps/support/1166071" target="_blank">here</a>',
            'Select Zendesk account from dropdown beside "What people are saying"',
            "Scroll to reviews section and review",
            `<a href="mailto:support@getmacha.com?subject=AI%20Ticket%20Translations%20-%20Add%20free%201%20week%20extension%20to%20my%20trial&body=Hey%20We've%20left%20a%20review%20for%20Macha%20on%20Zendesk%20and%20would%20like%20our%20free%201%20week%20trial%20extension.%20Thanks">Mail us</a> and let us know`,
          ],
        },
      },
      status: {
        show: false,
        status: "success",
        title: "Widget theme saved",
      },
    };
  },
  props: {},
  components: {
    TrialDays,
    TrialExtension,
    QuickstartGuides,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
  },
  watch: {},
  async created() {},
  methods: {
    async markGuideCompleted(index) {
      const data = { companyId: this.company._id, index };
      await CompanyService.MarkGuideCompleted(data);

      this.selectedApp.quickstartGuides[index].isCompleted = true;
    },
  },
};
</script>

<style scoped lang="scss">
.trial-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 7rem;
}

.trial-state {
  flex: 1;

  .btn {
    display: table;
    margin-top: 1rem;
  }
}

::v-deep {
  .trial-plan {
    display: block;

    .usage-wrapper {
      margin-top: 1rem;
    }
  }

  .trial-extension {
    flex: 1;
    max-width: 25rem;
  }
}
</style>
